import { SurveyItemType } from './types';

const questionVariants = {
  initial: (direction: 'forward' | 'backward') => ({
    opacity: 0,
    x: direction === 'forward' ? '0' : '-50%',
  }),
  animate: {
    opacity: 1,
    x: '0%',
    transition: { duration: 0.25 },
  },
  exit: (direction: 'forward' | 'backward') => ({
    opacity: 0,
    x: direction === 'forward' ? '-50%' : '0',
    transition: { duration: 0.25 },
  }),
};
const noAnimationVariants = {
  initial: { opacity: 1 },
  animate: { opacity: 1, transition: { duration: 0.1 } },
  exit: { opacity: 0, transition: { duration: 0.1 } },
};

const imageInterstitialVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.15 } },
  exit: { opacity: 0, transition: { duration: 0.15 } },
};

const sectionDividerVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.15 } },
  exit: { opacity: 0, transition: { duration: 0.15 } },
};

export function getAnimationVariants(surveyItem?: SurveyItemType) {
  if (!surveyItem) {
    return noAnimationVariants;
  }

  const { surveyItemType, type } = surveyItem;

  if (surveyItemType === 'question') {
    return questionVariants;
  } else if (surveyItemType === 'interstitial') {
    if (type === 'imageInterstitial') {
      return imageInterstitialVariants;
    } else {
      return sectionDividerVariants;
    }
  } else {
    return noAnimationVariants;
  }
}
